import { isoMeters } from "../../models/nominals";
import { RetailState } from "./models";

export const defaults: Readonly<RetailState> = {
    storesLoadedKey: "",
    isLoadingStores: false,
    stores: [],
    storeFilters: {
        limit: 500,
        // Default distance: 10km in meters (works for both miles and km sites)
        // - For km sites: 10km matches first dropdown option
        // - For miles sites: ~6.2 miles, first dropdown option is 10 miles
        distance: isoMeters.wrap(10000),
        category: null,
        retailerName: [],
    },
    focusedStoreID: null,
};
